import { render, staticRenderFns } from "./edit-admins.component.html?vue&type=template&id=5ce9b6c4&scoped=true&external"
import script from "./edit-admins.component.ts?vue&type=script&lang=ts&external"
export * from "./edit-admins.component.ts?vue&type=script&lang=ts&external"
import style0 from "./edit-admins.component.scss?vue&type=style&index=0&id=5ce9b6c4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce9b6c4",
  null
  
)

export default component.exports